import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import StepperSolicitacao from '@components/UI/Stepper/Index.jsx';
import StatusSolicitacaoComp from '@components/UI/StatusSolicitacao/Index.jsx';
import { getStatusOptions } from '@utils/Solicitacao/StatusOptions';
import { selectStatusById } from '@store/selectors/solicitacaoSelector';

const StatusSolicitacao = ({ idSolicitacao, flagAuditoria }) => {
  const statusNumero = useSelector(selectStatusById(idSolicitacao));
  const statusOptions = useMemo(() => getStatusOptions(flagAuditoria), [flagAuditoria]);

  // para o stepper, removemos AGENDADO_ENVIO (value = 'AGENDADO_ENVIO')
  const displayedStatusOptions = useMemo(
    () => statusOptions.filter(opt => opt.value !== 'AGENDADO_ENVIO'),
    [statusOptions]
  );

  // se for PENDENTE_ENVIO (1) ou AGENDADO_ENVIO (2), tratamos como 1
  const effectiveStatus = useMemo(
    () => (statusNumero === 2 ? 1 : statusNumero),
    [statusNumero]
  );

  const steps = useMemo(
    () =>
      displayedStatusOptions.map(opt => ({
        label: opt.label,
        description: opt.description,
        intValue: opt.intValue,
        displayValue: opt.displayValue  
      })),
    [displayedStatusOptions]
  );

  const activeStep = useMemo(
    () => displayedStatusOptions.findIndex(opt => opt.intValue === effectiveStatus),
    [displayedStatusOptions, effectiveStatus]
  );

  return (
    <div>
      <div className="col-12 col-md-12 d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-start">
          <h2 className="mb-0">Status:</h2>
          <h3 className="mx-3">
            <StatusSolicitacaoComp status={statusNumero} options={statusOptions} />
          </h3>
        </div>
        <button className="btn btn-menu d-flex align-items-end" type="button">
          <i className="fa-solid fa-bars"></i>
        </button>
      </div>

      <div className="mt-4">
        <StepperSolicitacao
          steps={steps}
          activeStep={activeStep}
          isFluxoConcluido={Number(statusNumero) === 7}
        />
      </div>
    </div>
  );
};

export default StatusSolicitacao;
